import { AccountSummary } from "components/pages/dashboard/accountSummary/AccountSummary";
import { useTranslation } from "react-i18next";
import { useRootSelector } from "store";
import { SliderPageWrapper } from "../../layout/sliderPageWrapper/SliderPageWrapper";

import classes from "./ManageAccount.module.scss";
import { selectedAccountInfo } from "store/account/account-selector";

export const ManageAccount = () => {
  const accountInfo = useRootSelector(selectedAccountInfo);
  const { t } = useTranslation(["account"]);
  return (
    <SliderPageWrapper headerTitle={t("account:account_summary")}>
      <div className={classes.ModuleWrapper}>
        <p>
          {t("account:current_account")}{" "}
          <span className={classes.AccountNo}>
            {" "}
            #{accountInfo?.accountNumber}
          </span>
        </p>
        <p className={classes.PageText}>{t("account:active_account_update")}</p>
        <div>
          <AccountSummary slider={true} />
        </div>
      </div>
    </SliderPageWrapper>
  );
};
